import * as React from 'react'
import { addDays, startOfDay } from 'date-fns'
import { Action } from 'redux-actions'
import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { doLogOut, getWhoAmI } from '../../../common/auth/authActions'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { store } from '../../../index'
import api from '../../../services/api.services'
import {
  ActivityProgress,
  BadgeDto,
  CompanyCountriesDto,
  DivisionDto,
  JoinCompany$Request,
  LeaveCompany$Request,
  ProgressType,
  ServiceProvider,
  SetUserCountry$Request,
  SetUserDivision$Request,
  UpdateUserProfile$Request,
  UserProfileDto,
} from '../../../services/api.types'
import { IChangePasswordPayload } from '../Settings'
import {
  changePassword,
  deleteUser,
  getUserCompanyCountries,
  getUserCompanyCountriesSuccess,
  getCompanyDivisions,
  getCompanyDivisionsSuccess,
  /*getUserActivity,
  getUserActivitySuccess,
  getUserBadges,
  getUserBadgesSuccess,*/
  updateUser,
  joinCompany,
  setUserDivision,
  setUserCountry,
  leaveCompany,
  togglePublicStatus,
  deleteUserOwnedCompany,
} from './SettingsActions'
import { getUserDto } from '../../../common/auth/authSelectors'
import { getErrorMsg } from '../../../common/helpers/translations'

/*function* sagaGetUserActivity({ payload }: Action<UserProfileDto>) {
  try {
    const { createdAt, userId } = payload
    const { activityProgress }: { activityProgress: ActivityProgress } = yield call(
      api.activity.getUserActivityProgressInPeriod,
      {
        endDate: startOfDay(addDays(new Date(), 1)).getTime(),
        progressType: ProgressType.ALL,
        startDate: startOfDay(createdAt).getTime(),
        userId,
      } as any,
    )
    yield put({ type: String(getUserActivitySuccess), payload: activityProgress })
  } catch (e: any) {
    const getUserActivityErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user activity load'),
    }

    yield put({ type: String(addNotification), payload: getUserActivityErrorNotification })
  }
}*/

/*function* sagaGetUserBadges({ payload }: Action<UserProfileDto>) {
  try {
    const { userId } = payload
    const { badges }: { badges: BadgeDto[] } = yield call(api.activity.getUserBadges, {
      userId,
    })
    yield put({ type: String(getUserBadgesSuccess), payload: badges })
  } catch (e: any) {
    const getUserBadgesErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('badges load'),
    }

    yield put({ type: String(addNotification), payload: getUserBadgesErrorNotification })
  }
}*/

function* sagaGetUserCompanyCountries() {
  try {
    const { companyCountries }: { companyCountries: CompanyCountriesDto[] } = yield call(
      api.users.getUserCompanyCountries,
    )
    yield put({ type: String(getUserCompanyCountriesSuccess), payload: companyCountries })
  } catch (e: any) {
    /*const ErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('countries load'),
    }
    yield put({ type: String(addNotification), payload: ErrorNotification })*/
    /*Bugsnag.notify(new Error('getUserCompanyCountries error'), function (event) {
      event.context = 'getUserCompanyCountries'
      event.addMetadata('error', e)
    })*/
  }
}

function* sagaGetCompanyDivisions() {
  try {
    const { divisionDtos }: { divisionDtos: DivisionDto[] } = yield call(api.users.getCompanyDivisions)
    yield put({ type: String(getCompanyDivisionsSuccess), payload: divisionDtos })
  } catch (e: any) {
    /*const ErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('groups load'),
    }
    yield put({ type: String(addNotification), payload: ErrorNotification })*/
    /*Bugsnag.notify(new Error('getCompanyDivisionsSuccess error'), function (event) {
      event.context = 'getCompanyDivisionsSuccess'
      event.addMetadata('error', e)
    })*/
  }
}

function* sagaUpdateUser({ payload }: Action<UpdateUserProfile$Request>) {
  try {
    const {
      dateOfBirth,
      firstName,
      gender,
      height,
      lastName,
      weight,
      divisionId,
      country,
      timeZone,
      units,
      newsletterSubscriber,
      onlyProfileUpdate,
    } = payload

    yield call(api.activity.updateUserProfile, {
      dateOfBirth,
      firstName,
      gender,
      height,
      lastName,
      weight,
      divisionId: divisionId ? divisionId : null,
      country,
      timeZone,
      units,
      newsletterSubscriber,
      onlyProfileUpdate,
    })

    // Update userDto...
    yield put({ type: String(getWhoAmI) })

    const updateUserSuccessNotification: INotification = {
      type: 'success',
      content: t`User successfully updated`,
    }

    yield put({ type: String(addNotification), payload: updateUserSuccessNotification })
  } catch (e: any) {
    // Update userDto...
    yield put({ type: String(getWhoAmI) })

    const updateUserFailNotification: INotification = {
      type: 'warning',
      content: t`Profile details missing. Last profile data synchronized`,
    }

    yield put({ type: String(addNotification), payload: updateUserFailNotification })
  }
}

function* sagaDeleteUser(action: Action<any>) {
  try {
    yield call(api.users.deleteUser, action.payload)
    store.dispatch(doLogOut())
    const deleteUserSuccessNotification: INotification = {
      type: 'success',
      content: t`User successfully deleted`,
    }

    yield put({ type: String(addNotification), payload: deleteUserSuccessNotification })
  } catch (e: any) {
    const deleteUserErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user deletion'),
    }

    yield put({ type: String(addNotification), payload: deleteUserErrorNotification })
  }
}

function* sagaChangePassword({ payload }: any) {
  try {
    const { oldPassword, newPassword, confirmPassword }: IChangePasswordPayload = payload
    if (newPassword !== confirmPassword) {
      const changePasswordInvalidNotification: INotification = {
        type: 'warning',
        content: t`Confirmation password does not match new password`,
      }

      yield put({ type: String(addNotification), payload: changePasswordInvalidNotification })

      return
    }
    yield call(api.auth.changePassword, {
      newPassword,
      oldPassword,
    })
    const changePasswordSuccessNotification: INotification = {
      type: 'success',
      content: t`Password successfully changed`,
    }

    yield put({ type: String(addNotification), payload: changePasswordSuccessNotification })
  } catch (e: any) {
    const changePasswordErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('password change'),
    }

    yield put({ type: String(addNotification), payload: changePasswordErrorNotification })
  }
}

function* sagaJoinCompany(action: Action<JoinCompany$Request>) {
  try {
    yield api.activity.joinCompany(action.payload)

    // Call only if integration is set (to prevent error).
    const userDto: UserProfileDto = yield select(getUserDto)
    const serviceProvider = userDto.serviceProvider as ServiceProvider
    if (serviceProvider) {
      yield call(api.activity.syncUserThirdPartyData)
    }

    //const response = yield call(api.activity.syncUserThirdPartyData)
    //yield put({ type: String(syncIntegrationSuccess), payload: response })

    yield put({ type: String(getWhoAmI) })
    yield put({ type: String(getCompanyDivisions) })
    yield put({ type: String(getUserCompanyCountries) })

    const successNotification: INotification = {
      type: 'success',
      content: t`Successfully joined`,
    }
    yield put({ type: String(addNotification), payload: successNotification })
  } catch (e: any) {
    if (e.message && e.message === 'invalidCompanyCode') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, the sign up code provided is not valid`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else if (e.message && e.message === 'disallowedDomain') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, the sign up code provided does not allow signing up with the specified email address. Please sign up using another email address or contact your employer.`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else if (e.message && e.message === 'disallowedRegion') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, the given sign up code does not allow signing up from your region.`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else if (e.message && e.message === 'userLimitExceeded') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, this community has exceeded it's user limit. Please contact your challenge organizer for more info.`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else {
      const toggleErrorNotification: INotification = {
        type: 'warning',
        content: getErrorMsg('joining'),
      }
      yield put({ type: String(addNotification), payload: toggleErrorNotification })
    }
  }
}

function* sagaLeaveCompany(action: Action<LeaveCompany$Request>) {
  try {
    const { companyName } = yield api.users.leaveCompany(action.payload)

    yield put({ type: String(getWhoAmI) })
    yield put({ type: String(getCompanyDivisions) })
    yield put({ type: String(getUserCompanyCountries) })

    const successNotification: INotification = {
      type: 'success',
      content: t`Successfully left ${companyName}`,
    }
    yield put({ type: String(addNotification), payload: successNotification })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('leaving'),
    }

    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

function* sagaDeleteUserOwnedCompany(action: Action<LeaveCompany$Request>) {
  try {
    const { companyName } = yield api.users.deleteUserOwnedCompany(action.payload)

    yield put({ type: String(getWhoAmI) })
    yield put({ type: String(getCompanyDivisions) })
    yield put({ type: String(getUserCompanyCountries) })

    const successNotification: INotification = {
      type: 'success',
      content: t`Successfully deleted ${companyName}`,
    }
    yield put({ type: String(addNotification), payload: successNotification })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user community deletion'),
    }

    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

function* sagaSetUserDivision(action: Action<SetUserDivision$Request>) {
  try {
    yield api.users.setUserDivision(action.payload)
    yield put({ type: String(getWhoAmI) })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user group change'),
    }

    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

function* sagaSetUserCountry(action: Action<SetUserCountry$Request>) {
  try {
    yield api.users.setUserCountry(action.payload)
    yield put({ type: String(getWhoAmI) })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user country change'),
    }

    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

function* sagaTogglePublicStatus() {
  try {
    yield api.users.togglePublicStatus()
    yield put({ type: String(getWhoAmI) })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('public challenge opt-in change'),
    }
    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

export function* settingsSagas() {
  yield all([
    //takeEvery(String(getUserActivity), sagaGetUserActivity),
    //takeEvery(String(getUserBadges), sagaGetUserBadges),
    takeEvery(String(getUserCompanyCountries), sagaGetUserCompanyCountries),
    takeEvery(String(getCompanyDivisions), sagaGetCompanyDivisions),
    takeEvery(String(deleteUser), sagaDeleteUser),
    takeEvery(String(changePassword), sagaChangePassword),
    takeEvery(String(updateUser), sagaUpdateUser),
    takeEvery(String(joinCompany), sagaJoinCompany),
    takeEvery(String(leaveCompany), sagaLeaveCompany),
    takeEvery(String(deleteUserOwnedCompany), sagaDeleteUserOwnedCompany),
    takeEvery(String(setUserDivision), sagaSetUserDivision),
    takeEvery(String(setUserCountry), sagaSetUserCountry),
    takeEvery(String(togglePublicStatus), sagaTogglePublicStatus),
  ])
}
